<template>
  <div>
    <div class="kf-footer kf-animate kf-animate-fade">
      <div class="g-box">
        <div class="__top">
          <img :src="require('../assets/img/logo_2.png')" class="__top_logo" />
        </div>
        <div class="__bd">
          <div class="__left">
            <div class="__menu">
              <div
                v-for="(item, index) in menuList"
                :key="index"
                @click="toPage(item)"
                class="__menu_item m-h n1"
                :class="{ n2: index === 1, n3: index === 2 }"
              >
                <div
                  class="__menu_img"
                  :style="{
                    backgroundImage: 'url(' + item.icon + ')'
                  }"
                ></div>
                <div class="__menu_cap">{{ item.name }}</div>
              </div>
            </div>
            <div class="__text">
              {{ copyRight }}<br />
              {{ address }}
            </div>
          </div>
          <div class="__about mla">
            <div class="__about_cap">关注我们</div>
            <div class="__about_bd">
              <div class="__about_item" v-if="wxImg">
                <div
                  class="__about_img"
                  :style="{
                    backgroundImage: 'url(' + wxImg + ')'
                  }"
                ></div>
                <div class="__about_label">微信</div>
              </div>
              <div class="__about_item" v-if="wbImg">
                <div
                  class="__about_img"
                  :style="{
                    backgroundImage: 'url(' + wbImg + ')'
                  }"
                ></div>
                <div class="__about_label">微博</div>
              </div>
              <div class="__about_item" v-if="xhsImg">
                <div
                  class="__about_img"
                  :style="{
                    backgroundImage: 'url(' + xhsImg + ')'
                  }"
                ></div>
                <div class="__about_label">小红书</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bt">
      Copyright © 2021 浙江华博特教育科技有限公司版权所有
      <a href="https://beian.miit.gov.cn/" target="_blank" class="m-h"
        >浙ICP备12019612号-1</a
      >
      <a
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011802000808"
        target="_blank"
        class="m-h"
      >
        <img :src="require('../assets/img/ico_33.png')" />
        浙公网安备 33011802000808号</a
      >
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      copyRight: "",
      address: "",
      wxImg: "",
      xhsImg: "",
      wbImg: "",
      menuList: []
    };
  },
  methods: {
    async init() {
      console.log("底部菜单2");
      this.menu.list.forEach(item => {
        if (item.name === "底部菜单") {
          this.menuList = item.subMenus;
          console.log(item.subMenus, "menulist");
        }
      });

      this.wxImg = await this.getMenuConfig("微信二维码", "image");
      this.wbImg = await this.getMenuConfig("微博二维码", "image");
      this.xhsImg = await this.getMenuConfig("小红书二维码", "image");
      this.copyRight = await this.getMenuConfig("版权", "title");
      this.address = await this.getMenuConfig("总部地址", "title");
    },
    async toPage(item) {
      this.toMenu(item.pageType, item.id);
    }
  }
};
</script>
<style lang="less">
.kf-footer {
  background: #002072;
  padding: 31px 0 75px 0;
  .__top_logo {
  }
  .__top {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-bottom: 30px;
  }
  .__bd {
    display: flex;
  }
  .__menu {
    display: flex;
    margin-top: 40px;
  }
  .__menu_item {
    display: block;
    margin-right: 100px;
    &.n1 {
      .__menu_img {
        // background-image: url("../assets/img/ico_5.png");
      }
    }
    &.n2 {
      .__menu_img {
        // background-image: url("../assets/img/ico_4.png");
      }
    }
    &.n3 {
      .__menu_img {
        // background-image: url("../assets/img/ico_3.png");
      }
    }
  }
  .__menu_img {
    width: 64px;
    height: 64px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin: 0 auto;
  }
  .__menu_cap {
    font-size: 18px;
    color: #ffffff;
    line-height: 25px;
    margin-top: 20px;
  }
  .__text {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
    line-height: 26px;
    margin-top: 43px;
  }
  .__about_cap {
    font-size: 18px;
    color: #ffffff;
    line-height: 25px;
    margin-top: 40px;
    text-align: center;
  }
  .__about_bd {
    display: flex;
    margin-top: 20px;
  }
  .__about_item {
    & + .__about_item {
      margin-left: 40px;
    }
  }
  .__about_img {
    width: 124px;
    height: 124px;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  .__about_label {
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    text-align: center;
    margin-top: 10px;
  }
}
.footer-bt {
  padding: 14px 0;
  background-color: #001062;
  color: #ffffff;
  display: flex;
  justify-content: center;
  a {
    display: flex;
    color: #ffffff;
    margin-left: 5px;
  }
  img {
    margin: 0 5px;
  }
}
</style>
